export const openModal = (modalConfig) => ({
  type: "OPEN_MODAL",
  payload: modalConfig,
});

export const closeModal = () => ({
  type: "CLOSE_MODAL",
});

export const updateModalTitle = (title) => ({
  type: "UPDATE_MODAL_TITLE",
  payload: title,
});
